export default function setup() {
    $(document).ready(function () {
        $('.favorite-icon').on('click', function (event) {
            favoritesBoat(event, $(this));
        });

        $('.gallary-action-save').on('click', function (event) {
            favoritesBoat(event, $(this));
        });

        function favoritesBoat(event, thisElement) {
            thisElement.toggleClass('active');
            event.preventDefault();
            var boatID = thisElement.parent().find('input[name="boatID"]');

            if (thisElement.hasClass('active')) {
                $.ajax({
                    url: '/Boat/SaveBoat',
                    type: 'GET',
                    data: boatID,
                    success: function (response) {
                        if (response) {
                            return;
                        }
                        else {
                            window.location.href = '/authentication/login';
                        }
                    },
                    error: function (xhr, status, error) {
                        // Handle errors (e.g., validation issues)
                        //console.log("Error occurred: " + error);
                        return;
                    }
                });
            } else {
                $.ajax({
                    url: '/Boat/RemoveBoat',
                    type: 'GET',
                    data: boatID,
                    success: function (response) {
                        return;
                    },
                    error: function (xhr, status, error) {
                        // Handle errors (e.g., validation issues)
                        //console.log("Error occurred: " + error);
                        return;
                    }
                });
            }
        }
    });        
}
